/**
 * Shallow copy of form values with leading/trailing whitespace removed from each string value.
 * Files, arrays, numbers, and null are unchanged. Use `skipKeys` for passwords etc.
 */
export function trimFormStringFields<T extends Record<string, unknown>>(
  values: T,
  skipKeys: readonly string[] = ['password']
): T {
  const skip = new Set(skipKeys);
  const out = { ...values };
  for (const key of Object.keys(out)) {
    if (skip.has(key)) {
      continue;
    }
    const v = out[key as keyof T];
    if (typeof v === 'string') {
      (out as Record<string, unknown>)[key] = v.trim();
    }
  }
  return out;
}
